export const IS_DEV = process.env.NODE_ENV === "development";

export const FINANCIAL_SITUATION_FINANCE_SPECIALIST =
  "I would like to speak to a construction home finance specialist";
export const FINANCIAL_SITUATION_PRE_APPROVAL =
  "I have pre approval for a home loan";
export const FINANCIAL_SITUATION_BUILDING_ESTIMATE =
  "I require a building estimate to obtain pre approval";
export const FINANCIAL_SITUATION_NOT_REQUIRED = "Not Required";

export const LAND_SITUATION_REGISTERED = "Registered land";
export const LAND_SITUATION_UNREGISTERED = "Unregistered land";
export const LAND_SITUATION_UNPURCHASED = "I’m looking to purchase land";

export const LAND_SITUATION_NSW_KIOSK_LOOKING = "I am looking for land";
export const LAND_SITUATION_NSW_KIOSK_HAVE = "I already have land";
export const LAND_SITUATION_NSW_DESKTOP_VACANT = "Currently own a vacant block of land";
export const LAND_SITUATION_NSW_DESKTOP_LOOKING = "Looking to purchase a vacant block of land";
export const LAND_SITUATION_NSW_DESKTOP_KDR = "Planning a knockdown rebuild project";
export const LAND_SITUATION_NSW_DESKTOP_HL = "Interest in House & Land Packages";

export const LEADS_STATUS_OLD =
  "I have already spoken to a new home consultant";
export const LEADS_STATUS_NEW =
  "I would like to speak to a new home consultant";
export const LEADS_STATUS_CURRENT =
  "I am currently building with Domaine Homes";

export const LEADS_STATUS_NSW_OLD = "I have already spoken to a Sales Consultant";
export const LEADS_STATUS_NSW_NEW = "Yes, I would like a sales consultant to make contact";
export const LEADS_STATUS_NSW_BROWSING = "I am just browsing";
